import {
  Alert,
  AlertDescription,
  Button,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from '@design-system';

import { Loader2, User } from 'lucide-react';

import { useSelfTestIntakeForm } from '@/features/invite-client';

export function SelfTestIntakeFormTab() {
  const { form, onSubmit, isLoading } = useSelfTestIntakeForm();

  return (
    <div className="space-y-6">
      <div>
        <h4 className="text-base font-semibold text-gray-950">Try Waterlily for Yourself</h4>
        <p className="text-foreground text-sm">
          Experience the intake form firsthand by building a plan for yourself. Your name is
          pre-filled from your advisor account.
        </p>
      </div>

      <Alert>
        <AlertDescription>
          This plan will be created using your advisor profile information. It is intended for you to
          experience the software as a client would.
        </AlertDescription>
      </Alert>

      <Form {...form}>
        <form
          onSubmit={onSubmit}
          className="space-y-6"
        >
          <div className="space-y-6">
            <FormField
              control={form.control}
              name="firstName"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>First name</FormLabel>
                  <FormControl>
                    <Input
                      disabled
                      className="bg-muted"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="lastName"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Last name</FormLabel>
                  <FormControl>
                    <Input
                      disabled
                      className="bg-muted"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>

          <Button
            type="submit"
            className="w-full"
            disabled={!form.formState.isValid || isLoading}
          >
            {isLoading ? (
              <>
                <Loader2 className="size-4 animate-spin" />
                Creating...
              </>
            ) : (
              <>
                <User className="size-4" />
                Try It for Yourself
              </>
            )}
          </Button>
        </form>
      </Form>
    </div>
  );
}
